exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.placeholder[data-v-ad144f34]{\r\n  display: none;\n}\r\n", ""]);

// exports
